/**
 * Mixin para conservar los filtros y la paginación de las tablas Vuetable-2
 * cuando el usuario navega a un detalle y regresa al listado.
 *
 * Uso en un componente:
 *   import persistTableFilters from "@/mixins/persistTableFilters";
 *   export default {
 *     mixins: [persistTableFilters],
 *     // Lista de variables de data() a conservar + clave única de almacenamiento
 *     persistConfig: {
 *       key: "compras_filtros",
 *       fields: ["search", "perPage", "searchLabel", "filterLabel",
 *                "fecha_inicio", "fecha_fin", "rangode_fecha"],
 *     },
 *     ...
 *   }
 *
 * Requisitos en la plantilla:
 *   - El <vuetable> debe tener ref="vuetable" y :load-on-start="false".
 * Requisitos en el script:
 *   - Llamar this.persistFiltros() dentro de onPaginationData().
 *   - Llamar this.iniciarTablaConFiltros() al final de mounted().
 *
 * Opcional: definir un método afterRestore(data) en el componente para
 * ejecutar lógica extra tras restaurar (p. ej. recargar selects dependientes).
 */
export default {
  data() {
    return {
      paginaRestaurada: 1,
    };
  },
  methods: {
    // Guarda el estado actual (filtros + página) en sessionStorage.
    persistFiltros() {
      const cfg = this.$options.persistConfig;
      if (!cfg || !cfg.key) return;
      const snapshot = {
        __page: this.$refs.vuetable ? this.$refs.vuetable.currentPage : 1,
      };
      (cfg.fields || []).forEach((f) => {
        snapshot[f] = this[f];
      });
      sessionStorage.setItem(cfg.key, JSON.stringify(snapshot));
    },
    // Restaura el estado guardado (si existe) antes de cargar la tabla.
    async restaurarFiltros() {
      const cfg = this.$options.persistConfig;
      if (!cfg || !cfg.key) return;
      const guardado = sessionStorage.getItem(cfg.key);
      if (!guardado) return;
      try {
        const data = JSON.parse(guardado);
        (cfg.fields || []).forEach((f) => {
          if (data[f] !== undefined) this[f] = data[f];
        });
        this.paginaRestaurada = data.__page || 1;
        if (typeof this.afterRestore === "function") {
          await this.afterRestore(data);
        }
      } catch (e) {
        console.error("Error al restaurar filtros de la tabla", e);
      }
    },
    // Restaura filtros y dispara la carga de la tabla en la página guardada.
    async iniciarTablaConFiltros() {
      await this.restaurarFiltros();
      this.$nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.currentPage = this.paginaRestaurada || 1;
          this.$refs.vuetable.reload();
        }
      });
    },
  },
};
